import React from 'react'
import './More2.css';

const More2 = () => {
  return (
    <div className='body46'>
    <div className="row46">
      <div className="imgWrapper46">
          <img src="/images/hero1.jpg" alt="" />
      </div>
      <div className="contentWrapper46">
          <div className="content46">
              <span className="textWrapper46">
                  {/* <span>New Collection</span> */}
              </span>
              <h2>PP Woven Sack Bags</h2>
              <p>One of the most economical packaging options for industries like cement, fertiliser, sugar, chemicals, food grains, etc. are small woven polypropylene sacks. We provide 100% custom-designed polypropylene woven bags and sacks in accordance with our clients’ demands and specifications.</p>
              <p>Reusable and recyclable at the same time, polypropylene is 100% recyclable. It therefore has no effect on the production of garbage. After a few uses, the manufacturers of woven bags and other vendors repurpose these bags to generate other consumable items</p>
              {/* <a href="/View">VIEW MORE</a> */}
              {/* <a href="/Contact">Contact Us</a> */}
          </div>
      </div>
    </div>
  </div>
  )
}

export default More2
